//========================================================================================
/*
  className     [str]
  disabled      [bool]
  selectedDays  [arr] 
  onChange      [func]

 */
//========================================================================================


import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

// Styles
import s from './DayRange.style';

// Services && Constants
import { selectedDaysList } from 'src/services/date';


const DayRange = (props) => {
  const { className, disabled, selectedDays, onChange, t } = props;

  const dayIsActive = (dayId) => Array.isArray(selectedDays) && selectedDays.includes(dayId);

  const updateDayRange = (dayId) => {
    let backArr = [];
    if (Array.isArray(selectedDays)) {
      if (selectedDays.includes(dayId)) {
        backArr = selectedDays.filter((id) => id !== dayId);
      } else {
        backArr = [...selectedDays, dayId];
      }
    }
    if (onChange) onChange(backArr);
  };

  return (
    <s.DayRangeWrapper className={className}>
      {selectedDaysList.map((el) => (
        <s.DayRangeButton
          key={el.title}
          disabled={disabled}
          active={dayIsActive(el.id)}
          onClick={() => { updateDayRange(el.id); }}
        >
          <span>{t(el.title)}</span>
        </s.DayRangeButton>
      ))}
      {!selectedDays || !selectedDays.length ? (<s.DayRangeErrorMessage>{t('error_filters_popup_1')}</s.DayRangeErrorMessage>) : null}
    </s.DayRangeWrapper>
  );
};
DayRange.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(DayRange);
